import * as yup from 'yup';

export const MapFloorValidation = yup.object({
  floorName: yup.string().min(3).max(25).required('Floor name is required'),
  mapUrl: yup.string(),
  // buildingId:yup.number().required(),
});
